import { Paperclip, ShieldAlert } from "lucide-react";
import { AiText, LevelBadge, label } from "./Ai";
import { fmtSize } from "../lib/files";
import { useT } from "../lib/i18n";

const EXPLAINABLE = ["bounced", "failed", "complained"];

export function MessageInsights({ m }) {
  const { lang } = useT();
  const sc = m.screening;
  const br = m.bounce_reason;
  return (
    <div className="space-y-5">
      {m.attachments?.length > 0 && (
        <div data-testid="message-attachments"><div className="mb-2 text-xs font-semibold uppercase tracking-wider text-zinc-500">Attachments</div>
          {m.attachments.map((a) => <div key={a.file_id} className="flex items-center gap-2 py-0.5 text-xs text-zinc-300"><Paperclip className="h-3.5 w-3.5 text-zinc-500" />{a.filename}<span className="text-zinc-600">{fmtSize(a.size)}</span></div>)}
        </div>)}
      {sc?.ai_classified && (
        <div className={`rounded-lg border p-3 text-xs ${sc.flagged ? "border-amber-500/30 bg-amber-500/5" : "border-white/10"}`} data-testid="message-screening">
          <div className="flex items-center gap-2"><ShieldAlert className={`h-4 w-4 ${sc.flagged ? "text-amber-300" : "text-zinc-500"}`} />
            <span className="text-zinc-300">Content screening:</span><LevelBadge level={sc.flagged ? "high" : "low"} text={sc.flagged ? `flagged · ${label(sc.category)}` : label(sc.category)} testId="message-screening-badge" /></div>
          {sc.flagged && <p className="mt-2 text-zinc-400">This message was sent, and flagged for review by the CARIO trust &amp; safety team because it resembles {label(sc.category).toLowerCase()} content.</p>}
        </div>)}
      {EXPLAINABLE.includes(m.status) && (
        <div className="space-y-3" data-testid="message-failure-insights">
          <div className="text-xs font-semibold uppercase tracking-wider text-zinc-500">{lang === "fi" ? "Miksi viestiä ei toimitettu" : "Why it wasn't delivered"}</div>
          {br?.ai_classified && <div className="text-xs text-zinc-300">{lang === "fi" ? "Syy" : "Reason"}: <LevelBadge level="medium" text={label(br.category)} testId="message-bounce-reason" /></div>}
          {m.bounce_diagnostic && <pre className="whitespace-pre-wrap rounded-md border border-white/10 bg-black/40 p-2 font-mono text-[11px] text-zinc-400">{m.bounce_diagnostic}</pre>}
          <AiText path={`/app/messages/${m.id}/explain`} cta="Explain in plain words" initial={(m.ai_explanation?.lang || "en") === lang ? m.ai_explanation?.text : undefined} key={lang} testId="message-explain" />
        </div>)}
    </div>
  );
}
